<template>
  <Headline :subtitle="'Unsere Expertise'" :seoStyle2="true">We ❤︎ OoH!</Headline>
  <div class="pt-16 pb-32 lg:my-5">
    <div class="container mx-auto max-w-screen-lg 2xl:max-w-screen-xl px-4 lg:px-0 mb-8">
      <div class="lg:text-center">
        <p class="inline-block p max-w-2xl pb-4 sm:pb-8 md:pb-12 mx-auto"><i>"Out-of-Home is where the audience is when they're out of home."</i></p>
      </div>
      <h2 class="h2">We love OoH</h2>
      <div class="max-w-5xl">
        <p>Wir begleiten seit 2018 Unternehmen wie Weischer, MfG Merchandiser for Goods, Ströer SAW und Brandstifter auf ihren Wegen zu maßgeschneiderter Software, zugeschnitten auf individuelle Bedürfnisse.</p>
        <p>Von einer Plattform, um OoH-Werbeflächen online zu buchen, bis hin zu umfassenden Systemen für Projekte-Management und Dokumenten-Verwaltung – alle Lösungen sind speziell auf die Bedürfnisse unserer Kunden und Out-of-Home zugeschnitten. Mit Detailliebe maßgeblich über das hinausgehend, wo Standardsoftware aufhört, anpassbar zu sein.</p>
      </div>
    </div>

    <section class="pt-16">
      <div class="mx-auto max-w-screen-md xl:max-w-screen-lg 2xl:max-w-screen-xl px-4 lg:px-0 flex flex-col md:flex-row">
        <div class="w-full md:w-3/5 mt-8 mb-16">
          <h2 class="h3">OoH Standorte verwalten</h2>
          <p>Ob Einzelhandel, Gastronomie oder Verkehrsknotenpunkte – verwaltet Eure Standorte zentral. Unterschiedliche Inhalte für verschiedene Locations, zeitgesteuerte Kampagnen, lokale Anpassungen. Alles von einer Stelle aus. Synchronisation, Fehlerbehandlung und Monitoring erfolgen automatisiert. Mit Möglichkeiten der Buchung von Plakatflächen und Werbeträgern.</p>
        </div>
        <div class="w-1/2 md:w-2/5 ml-32 inline-flex order-first md:order-none">
          <img class="object-contain" src="./../assets/img/ooh/5.png" alt="Content Management System">
        </div>
      </div>
    </section>

    <Container :bgColor="'#EFF6FF'" :styles="'pt-24'">
      <div class="mx-auto max-w-screen-md xl:max-w-screen-lg 2xl:max-w-screen-xl px-4 lg:px-0 flex flex-col md:flex-row">
        <div class="w-1/2 md:w-2/5 mr-32 inline-flex">
          <img class="object-contain" src="./../assets/img/ooh/4.png" alt="Content Management System">
        </div>
        <div class="w-full md:w-3/5 mt-6 mb-2">
          <h3 class="h3">Außendienst und Mediateam Steuerung</h3>
          <p>Mit unseren Software helfen wir Unternehmen beim Steuern von Out-of-Home Plakatierung und Anbringung. Versteht den Status Eurer Mediateam und Außendienstler besser. Unsere Lösung erfasst und verwaltet Aufträge und Aufgaben Eurer Mitarbeiter, und bietet Euch Reports und Analytics Möglichkeiten. Mit diesen Insights optimiert Ihr in Echtzeit die Kommunikation und Abarbeitung von on-the-road Aufträgen, und reduziert Zeitaufwände im Projektmanagement.</p>
        </div>
      </div>
    </Container>

    <section class="pt-16">
      <div class="mx-auto max-w-screen-md xl:max-w-screen-lg 2xl:max-w-screen-xl px-4 lg:px-0 flex flex-col md:flex-row">
        <div class="w-full md:w-3/5 mt-8 mb-16">
          <h3 class="h3">Digital Twin der analogen Akte</h3>
          <p>Wir haben die Erfahrung gemacht, dass die Digitalisierung von Dokumenten einer Lösung bedarf, die dynamisch wachsen kann bei sich verändernden Anforderung, wichtige Dokumente schnell und übersichtlich zu finden. Neben einer Content-Verteilung bietet so eine Lösung von digitalen Akten Tools zur Standorte-Planung und Schedulin g- alles mit einer intuitiven Benutzeroberfläche, um den Anforderungen von weniger IT-affinen Mitarbeitern gerecht zu werden.</p>
        </div>
        <div class="w-1/2 md:w-2/5 ml-32 inline-flex order-first md:order-none">
          <!-- <img class="object-contain" src="./../assets/img/ooh/3.png" alt="Content Management System"> -->
          <img class="object-contain" src="./../assets/img/ooh/6.png" alt="Content Management System">
          <!-- <img class="object-contain" src="./../assets/img/ooh/2.png" alt="Content Management System"> -->
        </div>
      </div>
    </section>

    <!-- <Container :bgColor="'#F0F8FC'" :styles="'pt-24'">
      <div class="mx-auto max-w-screen-md xl:max-w-screen-lg 2xl:max-w-screen-xl px-4 lg:px-0 flex flex-col md:flex-row">
        <div class="w-1/2 md:w-2/5 mr-32 inline-flex">
        </div>
        <div class="w-full md:w-3/5 mt-8">
          <h3 class="h3">4.&nbsp;&nbsp;Interaktivität & Engagement</h3>
          <p>Statische Displays sind Vergangenheit. Moderne OoH-Lösungen bieten Touch-Interaktionen, QR-Code Integration und mobile Connectivity. Besucher können direkt mit Ihren Inhalten interagieren – und Sie erhalten Daten über diese Interaktionen. Das schafft emotionale Bindung und messbare Ergebnisse.</p>
        </div>
      </div>
    </Container> -->

    <Container class="mt-16 py-6 sm:pb-8 px-4 lg:px-0" :styles="'py-6 sm:pb-8 pt-16 sm:pt-24'">
      <h2 class="h1 mx-auto mb-8">Unsere OoH Plattformen</h2>
      <p>Wir bieten jahrelange Praxiserfahrung in der Individualentwicklung von Software für die Out of Home Branche, die zuverlässig funktionieren. Wir verstehen die besonderen Anforderungen des OoH-Marktes: Hochverfügbarkeit, Remote-Management und Performance unter Last.</p>
      
      <div class="md:flex text-center lg:mx-16 mt-8 lg:mt-12 mb-12">
        <div class="flex-1 hover:bg-gray-100 rounded pt-4">
          <img src="./../assets/img/icons/konzept.svg" class="mx-auto h-16 lg:h-28" alt="">
          <h3 class="h2 w-9/12 2xl:w-7/12 mx-auto mt-4 mb-4">Architektur</h3>
          <p class="px-4">Wir setzen für skalierbare Cloud-Infrastruktur auf C#, .NET und Azure und Azure DevOps.</p>
        </div>
        <div class="flex-1 hover:bg-gray-100 rounded pt-4">
          <img src="./../assets/img/icons/code.svg" class="mx-auto h-16 lg:h-28" alt="">
          <h3 class="h2 w-9/12 2xl:w-7/12 mx-auto mt-4 mb-4">Datenverarbeitung</h3>
          <p class="px-4">Echtzeit-Analytics mit SQL Server und asynchroner Code-Ausführung.</p>
        </div>
        <div class="flex-1 hover:bg-gray-100 rounded pt-4">
          <img src="./../assets/img/icons/werkzeug.svg" class="mx-auto h-16 lg:h-28" alt="">
          <h3 class="h2 w-9/12 2xl:w-7/12 mx-auto mt-4 mb-4">Integration</h3>
          <p class="px-4">Nahtlose Integration mit bestehenden internen Systemen für optimale User Experience.</p>
        </div>
      </div>
    </Container>

    <div class="container mx-auto max-w-screen-lg 2xl:max-w-screen-xl px-4 lg:px-0 mt-16">
      <div class="bg-blue-50 rounded-lg p-8 text-center mb-16">
        <h3 class="h2 mb-4" style="color: #214979;">Bereit für einen Partner mit OoH Erfahrung?</h3>
        <p class="mb-6 max-w-2xl mx-auto">Lasst uns gerne einmal austauschen, um Eure Anforderungen zu einer maßgeschneiderten Plattform zu besprechen. Denn wir glauben an Software, die Euer Out-of-Home Business vereint und Eure Mitarbeiter effizienter werden lassen.</p>
        <CtaButton class="border-gray-500 text-gray-700 hover-my-gradient hover:border-transparent hover:text-white" @clicked="onClick">Kontakt aufnehmen</CtaButton>
      </div>
      <ContactInfos />
    </div>
    
  </div>
</template>

<script>
import Headline from '../views/Headline.vue'
import ContactInfos from './../views/ContactInfos.vue'
import Container from './../views/Container.vue'
import CtaButton from './../views/CtaButton.vue'

export default {
  name: 'OutOfHomeSoftware',
  components: {
    Headline,
    ContactInfos,
    Container,
    CtaButton
  },
  methods: {
    scrollToTop() {
      window.scrollTo(0, 0)
    },
    onClick() {
      this.$router.push({name: 'contact'})
      this.scrollToTop()
    }
  }
}
</script>

<style scoped>
p {
  margin-top: 0.5rem;
  line-height: 1.4em;
}

h2.h3, h3.h3 {
  font-weight: bold;
  color: #054374;
  font-size: 2.0em;
  margin: 0;
}

.list {
  list-style: none;
  padding: 0;
}

.list li {
  position: relative;
  padding-left: 24px;
  background-image: none;
}

.list li:before {
  content: '✓';
  position: absolute;
  left: 0;
  color: #0291D8;
  font-weight: bold;
  font-size: 1.2em;
}
</style>
